import { render, staticRenderFns } from "./weChatRecharge.vue?vue&type=template&id=39da0af4&scoped=true&"
import script from "./weChatRecharge.vue?vue&type=script&lang=js&"
export * from "./weChatRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da0af4",
  null
  
)

export default component.exports